import { SelectOption } from '@consigli/facade';
import { ConflictType } from '@consigli/types';
import { formatEnumToReadableText } from '@consigli/utils';
import { useMemo } from 'react';

import { Fieldset, Field, Select, TextArea } from '@/components';

import { FindingFormData, FormErrors } from './types';

interface ConflictFieldsetProps {
  legend: string;
  formData: FindingFormData;
  errors: FormErrors;
  updateFormData: (field: keyof FindingFormData, value: unknown) => void;
}

export const ConflictFieldset = ({
  legend,
  formData,
  errors,
  updateFormData,
}: ConflictFieldsetProps) => {
  const conflictTypeOptions: SelectOption[] = useMemo(
    () =>
      Object.values(ConflictType).map((value) => ({
        label: formatEnumToReadableText(String(value)),
        value: String(value),
      })),
    [],
  );
  return (
    <Fieldset legend={legend}>
      <Field
        label="Conflict message"
        htmlFor="conflict-message"
        required
        error={errors.conflictMessage}
      >
        <TextArea
          rows={5}
          placeholder="Enter the conflict message"
          className="w-full"
          value={formData.conflictMessage || ''}
          onChange={(e) => updateFormData('conflictMessage', e.target.value)}
        />
      </Field>
      <Field
        label="Conflict message (English)"
        htmlFor="conflict-message-en"
        required
        error={errors.conflictMessageEn}
      >
        <TextArea
          rows={5}
          placeholder="Enter the conflict message (English)"
          className="w-full"
          value={formData.conflictMessageEn || ''}
          onChange={(e) => updateFormData('conflictMessageEn', e.target.value)}
        />
      </Field>
      <Field label="Conflict type" htmlFor="conflict-type" required error={errors.conflictType}>
        <Select
          className="w-full"
          options={conflictTypeOptions}
          getOptionLabel={(option) => option.label}
          getOptionValue={(option) => String(option.value)}
          value={conflictTypeOptions.find(
            (option) => String(option.value) === formData.conflictType,
          )}
          onValueChange={(option) => updateFormData('conflictType', option?.value || null)}
        />
      </Field>
    </Fieldset>
  );
};
